// extracted by mini-css-extract-plugin
export var actionIcon = "title-product-module--actionIcon--e5fc5";
export var actionItem = "title-product-module--actionItem--3aff0";
export var actionItemLink = "title-product-module--actionItemLink--1e842";
export var actionNoLink = "title-product-module--actionNoLink--1a058";
export var actionRoot = "title-product-module--actionRoot--8109e";
export var dividerContent = "title-product-module--dividerContent--6c947";
export var dividerContentItem = "title-product-module--dividerContentItem--d672e";
export var horizontalBar = "title-product-module--horizontalBar--ddcef";
export var labelContent = "title-product-module--labelContent--fe8ab";
export var noIcon = "title-product-module--noIcon--0274b";
export var rootTitle = "title-product-module--rootTitle--22993";
export var subtitle = "title-product-module--subtitle--ebfa5";
export var subtitleContent = "title-product-module--subtitleContent--91cb6";
export var title = "title-product-module--title--15b2a";